<template>
    <div>
        <section v-for="block in blocks">
            <SSLandingView v-if="block.type == 'ss_landing'" :block='block' />
            <RawView v-if="block.type == 'raw' || block.type == 'html'" :block='block' />
            <DoubleColumnView v-if="block.type == 'double_column'" :block='block'/>
            <StudentMaterialsView v-if="block.type == 'student_materials'" :block='block' />
            <TeacherMaterialsView v-if="block.type == 'teacher_materials'" :block='block' :publications='publications' />
            <OnlineView v-if="block.type == 'online'" :block='block' />
            <WhatYouGetView v-if="block.type == 'wyg'" :block='block' />
            <FlipBookView v-if="block.type == 'flipbook'" :block='block' />
            <StaticPage v-if="block.type == 'static'" :block='block'/>
            <Standards v-if="block.type == 'standards'" :block='block' :publications='publications' />
        </section>
    </div>
</template>

<script>
import RawView from "@/components/blocks/RawView";
import DoubleColumnView from "@/components/blocks/DoubleColumnView";
import StudentMaterialsView from "@/components/blocks/StudentMaterialsView";
import TeacherMaterialsView from "@/components/blocks/TeacherMaterialsView";
import OnlineView from "@/components/blocks/OnlineView";
import WhatYouGetView from "@/components/blocks/WhatYouGetView";
import FlipBookView from "@/components/blocks/FlipBookView";
import StaticPage from "@/components/blocks/StaticPage.vue";
import SSLandingView from "@/components/blocks/SSLandingView";
import Standards from "@/components/blocks/Standards";
export default {
    name: "BlockListViewer",
    components: {
        Standards,
        SSLandingView, StaticPage, FlipBookView, WhatYouGetView, OnlineView, TeacherMaterialsView, StudentMaterialsView, DoubleColumnView, RawView
    },
    props: {
        blocks: Array,
        publications: {
            default: () => ([]),
            type: Array,
        },
    }
}
</script>

<style scoped>

</style>